import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getListAllTags, deleteZone, createZone, updataZone } from '@blade-sxp/task-management/api/creat-task/index';
import { isEmpty } from 'lodash';
const Service = {
    getListAllTags,
    deleteZone,
    createZone,
    updataZone,
};
let EditAreaType = class EditAreaType extends Vue {
    editAreaType;
    returnIcon = require('@blade-sxp/task-management/assets/return-icon.png');
    addICON = require('@blade-sxp/task-management/assets/add.png');
    closeIcon = require('@blade-sxp/task-management/assets/close.png');
    overIcon = require('@blade-sxp/task-management/assets/over.png');
    selectList = [];
    loadState = false;
    dialogVisible = false;
    get isAdd() {
        return this.selectList?.length >= 5;
    }
    onchangeEditAreaType(val) {
        this.dialogVisible = val;
        if (val) {
            this.getDataList();
        }
    }
    isShowDelete(item) {
        return item?.type !== 'ENTIRE_ZONE';
    }
    submitData(item, index) {
        const { btnType } = item;
        if (btnType === 'add') {
            this.createZoneData(item, index);
        }
        else {
            this.updataZoneData(item, index);
        }
    }
    getDataList() {
        this.selectList = [];
        this.loadState = true;
        Service.getListAllTags()
            .then((res) => {
            if (!isEmpty(res)) {
                this.selectList = res?.map((item) => {
                    return {
                        ...item,
                        editStatus: true,
                        btnType: 'edit',
                    };
                });
            }
        })
            .finally(() => {
            this.loadState = false;
        });
    }
    createZoneData(item, index) {
        const { name } = item;
        if (!name) {
            this.$message({
                message: `${this.$t('zoneTip')}`,
                type: 'error',
                customClass: 'edit-area-type-message',
            });
            return;
        }
        const param = {
            name,
            type: 'CUSTOM_ZONE',
        };
        Service.createZone(param)
            .then((res) => {
            this.$message({
                message: `${this.$t('createS')}`,
                type: 'success',
                customClass: 'edit-area-type-message',
            });
            const id = res;
            this.selectList[index].editStatus = true;
            this.selectList[index].btnType = 'edit';
            this.selectList[index].id = id;
        })
            .catch(() => {
            this.$message({
                message: `${this.$t('createE')}`,
                type: 'error',
                customClass: 'edit-area-type-message',
            });
            this.selectList[index].editStatus = false;
            this.selectList[index].btnType = 'add';
        });
    }
    updataZoneData(item, index) {
        const { name, type, id } = item;
        const param = {
            name,
            tagId: id,
            type,
        };
        Service.updataZone(param).then(() => {
            this.$message({
                message: `${this.$t('deitS')}`,
                type: 'success',
                customClass: 'edit-area-type-message',
            });
            this.selectList[index].editStatus = true;
        });
    }
    deleteZoneData(id, index) {
        Service.deleteZone(id).then((item) => {
            this.$message({
                message: `${this.$t('deleteS')}`,
                type: 'success',
                customClass: 'edit-area-type-message',
            });
            this.selectList.splice(index, 1);
        });
    }
    handleClose() {
        this.dialogVisible = false;
        this.$emit('close', false);
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    addAreaType() {
        const id = String(this.taskId());
        const objArea = {
            id: id,
            name: '',
            taskCount: 0,
            type: 'CUSTOM_ZONE',
            editStatus: false,
            btnType: 'add',
        };
        this.selectList.push(objArea);
        this.$nextTick(() => {
            this.$refs['input' + id][0].focus();
        });
    }
    onEdit(index) {
        this.selectList[index].editStatus = false;
    }
    onClear(index) {
        this.selectList[index].name = '';
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], EditAreaType.prototype, "editAreaType", void 0);
__decorate([
    Watch('editAreaType', { immediate: true })
], EditAreaType.prototype, "onchangeEditAreaType", null);
EditAreaType = __decorate([
    Component({
        name: 'EditAreaType',
        components: {},
        i18n: {
            messages: {
                zh: {
                    areaType: '区域类型',
                    areaPlaceHolder: '选择区域类型',
                    edit: '编辑',
                    addAreaType: '添加区域类型',
                    editAreaType: '编辑区域类型',
                    return: '返回',
                    createS: '创建成功',
                    createE: '创建失败',
                    deleteS: '删除成功',
                    deitS: '编辑成功',
                    zoneTip: '区域名不能为空',
                },
                en: {
                    areaType: 'Area Type',
                    areaPlaceHolder: 'select area type',
                    edit: 'Edit',
                    addAreaType: 'Add Area Type',
                    editAreaType: 'Edit Area Type',
                    return: 'Return',
                    createS: 'Created Successfully',
                    createE: 'Creation Failed',
                    deleteS: 'Successfully Deleted',
                    deitS: 'Successfully Edited',
                    zoneTip: 'Area name cannot be empty',
                },
            },
        },
    })
], EditAreaType);
export default EditAreaType;
